import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import AboutUs from "./components/AboutUs/AboutUs";
import Blog from "./components/Blog/Blog";
import BlogDetails from "./components/BlogDetails/BlogDetails";
import Contact from "./components/Contact/Contact";
import CourseDetails from "./components/CourseDetails/CourseDetails";
import CourseList from "./components/CourseList/CourseList";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import ScholarDetails from "./components/ScholarDetails/ScholarDetails";
import ScholarList from "./components/ScholarList/ScholarList";
import ScrollToTop from "./components/ScrollToTop/scrollToTop";

function App() {
  return (
    <>
      <Router>
        <Header />
        <ScrollToTop />

        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route path="/about" element={<AboutUs />}></Route>
          <Route path="/courses" element={<CourseList />}></Route>
          <Route path="/course/:id" element={<CourseDetails />}></Route>
          <Route path="/scholars" element={<ScholarList />}></Route>
          <Route path="/scholar/:id" element={<ScholarDetails />}></Route>
          <Route path="/blogs" element={<Blog />}></Route>
          <Route path="/blog/:id" element={<BlogDetails />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
